export default {
    Collection: 'collection',
    Record: 'record'
}
